var _defs, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRrLogoLsp2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.93 144.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#35b399;}.cls-2{fill:#3b4a4d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RR_Logo_Lsp2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.13,
    y: 86.77,
    width: 17.02,
    height: 17.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.86,
    y: 69.75,
    width: 17.02,
    height: 34.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.25,
    y: 52.72,
    width: 17.02,
    height: 51.06
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 112.78,
    y: 35.7,
    width: 17.02,
    height: 68.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.75,103.87V99h-5.92v4.87h-2.27V91.81h2.27v5.08h5.92V91.81H170v12.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.14,97.89c0,3.12-1.95,6.23-6.18,6.23a5.87,5.87,0,0,1-6.2-6.21c0-3.17,2-6.35,6.2-6.35A6,6,0,0,1,189.14,97.89ZM179,97.94c.05,2,1.12,4.1,4,4.1s3.91-2.13,3.94-4.11-1.1-4.3-3.94-4.3S179,95.91,179,97.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.1,94.71a3.45,3.45,0,0,0-2.86-1.34c-1.69,0-2.5.71-2.5,1.6,0,1.05,1.24,1.34,2.69,1.52,2.51.31,4.85,1,4.85,3.84,0,2.69-2.38,3.84-5.06,3.84-2.46,0-4.36-.76-5.25-3l1.89-1a3.43,3.43,0,0,0,3.39,1.91c1.43,0,2.77-.5,2.77-1.81,0-1.14-1.19-1.6-2.79-1.77-2.46-.29-4.73-.95-4.73-3.65,0-2.48,2.44-3.49,4.67-3.51,1.88,0,3.82.53,4.73,2.39Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.61,100.3H217.2v3.55h-2.27V91.8l5.68,0A4.26,4.26,0,1,1,220.61,100.3Zm-3.41-2.08h3.41a2.14,2.14,0,1,0,0-4.27H217.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.47,103.85V91.8h2.26v12.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.76,93.86h-3.82V91.8h9.92v2.07H251v10h-2.27Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271,101.58h-6.3l-1,2.27h-2.46l5.41-12.05h2.48l5.41,12.05H272Zm-3.15-7.25-2.24,5.13h4.48Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.49,91.8v10h6.2v2.1h-8.47V91.8Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.2,103.85V91.8h2.26v12.05Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.14,93.86h-3.82V91.8h9.92v2.07h-3.82v10h-2.27Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334,96.77l3.2-5h2.74v.1l-4.8,7v5h-2.27v-5l-4.63-7v-.1h2.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.52,101.58h-6.3l-1,2.27h-2.46l5.41-12.05h2.48L375,103.85h-2.48Zm-3.15-7.25-2.24,5.13h4.48Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.16,91.78h2.27v12.07H391v0l-6.34-8.14v8.13h-2.27V91.8h1.84l5.9,7.47Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.61,101.58h-6.3l-1,2.27h-2.46l5.41-12.05h2.48l5.41,12.05h-2.48Zm-3.15-7.25-2.24,5.13h4.48Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.12,91.8v10h6.2v2.1h-8.47V91.8Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.39,96.77l3.2-5h2.74v.1l-4.8,7v5h-2.27v-5l-4.63-7v-.1h2.7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M457,93.86h-3.82V91.8h9.92v2.07h-3.82v10H457Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.7,103.85V91.8H474v12.05Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.6,102.33a6.35,6.35,0,0,1-4.58,1.79c-4.48,0-6.37-3.08-6.39-6.21A6.07,6.07,0,0,1,489,91.56a6.22,6.22,0,0,1,4.42,1.84l-1.51,1.46A4.14,4.14,0,0,0,489,93.72a4,4,0,0,0-4.15,4.18A3.86,3.86,0,0,0,489,102a4.44,4.44,0,0,0,3-1.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509,94.71a3.45,3.45,0,0,0-2.86-1.34c-1.69,0-2.5.71-2.5,1.6,0,1.05,1.24,1.34,2.69,1.52,2.51.31,4.85,1,4.85,3.84,0,2.69-2.38,3.84-5.06,3.84-2.46,0-4.36-.76-5.25-3l1.89-1a3.43,3.43,0,0,0,3.39,1.91c1.43,0,2.77-.5,2.77-1.81,0-1.14-1.19-1.6-2.79-1.77-2.46-.29-4.73-.95-4.73-3.65,0-2.48,2.44-3.49,4.67-3.51,1.88,0,3.82.53,4.73,2.39Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178,74.35l-5.56-9.78h-6.71v9.78h-6.14V50.17a3.09,3.09,0,0,1,3.07-3.07h12.27a8.68,8.68,0,0,1,9,8.75,8.59,8.59,0,0,1-5,7.81L185,74.35Zm-4.34-22.29h-7.94v7.73h7.94a3.88,3.88,0,0,0,3.93-3.93A3.77,3.77,0,0,0,173.62,52.05Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.13,74.35V47.11h6.14V74.35Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M218.13,74.8c-8.06,0-14.52-5.89-14.52-14.07,0-8.67,6.14-14,15-14a26.88,26.88,0,0,1,8.84,1.55l-1.27,5.11a25.9,25.9,0,0,0-7-1.23c-6.34,0-9.45,3-9.45,8.59,0,4.87,3.23,8.63,8.39,8.63a7,7,0,0,0,5.6-2.21V60.48h6.05v7.85C227.94,71.85,223.48,74.8,218.13,74.8Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255.06,74.35v-11H242.87v11h-6.14V47.11h6.14V57.9h12.19V47.11h6.09V74.35Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.75,52.46V74.35h-6.14V52.46H267.7V47.11h24v5.36Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.5,74.35l-5.56-9.78h-6.71v9.78H309.1V50.17a3.09,3.09,0,0,1,3.07-3.07h12.27a8.68,8.68,0,0,1,9,8.75,8.59,8.59,0,0,1-5,7.81l6.18,10.68Zm-4.34-22.29h-7.94v7.73h7.94a3.88,3.88,0,0,0,3.93-3.93A3.77,3.77,0,0,0,323.17,52.05Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M343.54,74.35a3.09,3.09,0,0,1-3.07-3.07V50.17a3.09,3.09,0,0,1,3.07-3.07h16.93v5.28H346.6v5.44h9.94a2.65,2.65,0,0,1,2.66,2.66,2.62,2.62,0,0,1-2.66,2.62H346.6v6h13.87v5.28Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M382.15,72.88a2.85,2.85,0,0,1-5.24,0L366.4,47.11h6.05l7.08,17.34,7.08-17.34h6.05Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.46,74.35a3.09,3.09,0,0,1-3.07-3.07V50.17a3.09,3.09,0,0,1,3.07-3.07h16.93v5.28H404.52v5.44h9.94a2.65,2.65,0,0,1,2.66,2.66,2.62,2.62,0,0,1-2.66,2.62h-9.94v6h13.87v5.28Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M448.5,74.55a3,3,0,0,1-2.74-1L432.3,57.78V74.35h-6.14V49.89a3.09,3.09,0,0,1,3.07-3.07,2.74,2.74,0,0,1,2.33,1.06s4.25,5,13.46,15.71V47.11h6.14V71.53A3,3,0,0,1,448.5,74.55Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M471.2,74.8c-7.4,0-12.27-5.48-12.27-11.78V47.11h6.14V63c0,3.93,2.58,6.3,6.14,6.3s6.09-2.37,6.09-6.3V47.11h6.14V63C483.43,69.32,478.6,74.8,471.2,74.8Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M493.45,74.35a3.09,3.09,0,0,1-3.07-3.07V50.17a3.09,3.09,0,0,1,3.07-3.07h16.93v5.28H496.52v5.44h9.94a2.65,2.65,0,0,1,2.66,2.66,2.62,2.62,0,0,1-2.66,2.62h-9.94v6h13.87v5.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrLogoLsp2);
export default __webpack_public_path__ + "static/media/RR_Logo_Lsp2.41706e25d4c3b6575de89dcf1b3d437b.svg";
export { ForwardRef as ReactComponent };